import React from 'react'
import './Contact.css'
export default function Contact() {
  return (
    <div className='contactbody'>
      <div className="contact1">
        <h3>Have a</h3>
        <h3><i className="fas fa-coffee"></i></h3>
        <h3>With me :)</h3>
        <div className="line"></div>
        <p>Email me:</p>
        <p>mishrasatyabrata27@gmail.com</p>
        <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/satyabrata-mishra-52ab58218"><i className="fa fa-linkedin" style={{ fontSize: "1.6rem", color: "black" }}></i></a>
        <a target="_blank" rel="noreferrer" href="https://instagram.com/s_.mishra"><i className="fa fa-instagram" style={{ fontSize: "1.6rem", color: "black" }}></i></a>
        <a target="_blank" rel="noreferrer" href="https://github.com/satyabrata-mishra"><i className="fa fa-github" style={{ fontSize: "1.6rem", color: "black" }}></i></a>
      </div>
      </div>
  )
}
